import styled from 'styled-components';

const EBarEnactmentsResultDiv = styled.div`
  width: 100%;
`;

EBarEnactmentsResultDiv.displayName = 'EBarEnactmentsResultDiv';

export default EBarEnactmentsResultDiv;
